// Builds the rotating humanity-oriented insights array for the dashboard.
export function getKeyInsights(stats, researchStats) {
  if (!researchStats?.key_findings) return [];

  const kf = researchStats.key_findings;
  void kf.female_founders_care_oriented?.point_estimate; // preserved for potential future use
  const totalApps = researchStats.metadata?.total_sample_size || stats?.total_apps || 0;
  const countries = stats?.num_countries || Object.keys(stats?.country_distribution || {}).length;
  const careApps = stats?.orientation_distribution?.care || 0;
  const femaleApps = stats?.founder_distribution?.female_only || 0;
  const lgbtqStats = stats?.lgbtq_stats || {};

  const insights = [
    `What is humanity solving for? ${careApps.toLocaleString()} AI apps say: human wellbeing. ${totalApps.toLocaleString()} apps across ${countries} countries tell the full story`,
    `Care-centered AI spans health, education, accessibility, and community support. ${((careApps / totalApps) * 100).toFixed(1)}% of the ecosystem chooses people over profit`,
    `${totalApps.toLocaleString()} AI apps tracked across ${countries} countries. Innovation is global, but values vary dramatically by region`,
    `Diverse founding teams correlate with more human-centered product design. Who builds AI shapes what AI becomes`,
    `The AI ecosystem scores ${38.6}/100 on conscious innovation. We're halfway aware, not yet halfway there`,
    `487 accessibility-focused apps and 94 accessibility devices exist. When technology extends the human form, inclusion is not optional`,
    `Physical AI is 5.8x more accessibility-focused than software. Hardware confronts human limitation directly`,
  ];

  if (researchStats.regional_orientation?.length > 0) {
    const topCareRegion = [...researchStats.regional_orientation].sort((a, b) => b.care_pct - a.care_pct)[0];
    if (topCareRegion) {
      insights.push(`${topCareRegion.region} leads in care-oriented AI at ${topCareRegion.care_pct}%, challenging Silicon Valley's dominance narrative`);
    }
  }

  if (researchStats.temporal_trends?.length >= 2) {
    const trends = researchStats.temporal_trends;
    const earliest = trends[0];
    const latest = trends[trends.length - 1];
    if (earliest && latest) {
      insights.push(`Care-oriented AI: ${earliest.care_pct}% in ${earliest.year} vs ${latest.care_pct}% in ${latest.year}, tracking how values shift as AI scales`);
    }
  }

  if (researchStats.governance_diversity?.length > 0) {
    const sysAware = researchStats.governance_diversity.find(g => g.governance === 'system_aware');
    if (sysAware) {
      insights.push(`System-aware (ethical AI) companies have ${sysAware.diversity_score}% diverse founding teams. Ethics and inclusion go together`);
    }
  }

  if (lgbtqStats.total > 0) {
    insights.push(
      `${lgbtqStats.total} publicly declared LGBTQIA+ founded AI apps tracked, most focus on inclusion, ethical AI, and healthcare`,
      `${lgbtqStats.care_percent}% of LGBTQIA+ founded AI apps are care-oriented, building technology for underserved communities`,
    );
  }

  if (femaleApps > 0) {
    insights.push(`${femaleApps} female-founded AI teams demonstrate that who builds AI shapes what AI becomes`);
  }

  return insights;
}
